export default __webpack_public_path__ + "5311f30e76867ec595ceeeda39d82a3b.jpg";